export default __webpack_public_path__ + "static/media/medicaltest_date_icon.90d26d26.svg";